import { createFileRoute } from "@tanstack/react-router";
import { DeptContentList } from "@/components/dept-content/DeptContentList";
import { COE_DOCUMENTS } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/coe/documents/")({
  component: () => <DeptContentList cfg={COE_DOCUMENTS} />,
});
